import styled from "@emotion/styled";

export const PricingDefinitionModalWrapper = styled.div(({ theme }) => ({
	color: theme.project.colors.fontColors.main,
	maxHeight: "600px",
	maxWidth: "600px",
	width: "calc(100% - 32px)",
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	backgroundColor: "white",
	overflowY: "auto",
	display: "flex",
	flexDirection: "column",
	boxSizing: "border-box",
	boxShadow: `
        0px 11px 15px -7px #00000033,
        0px 24px 38px 3px #00000024,
        0px 9px 46px 8px #0000001F
    `,
	borderRadius: "4px"
}));

export const PricingDefinitionModalContent = styled.div(({ theme }) => ({
	padding: "0px 24px 24px",
	display: "flex",
	flexDirection: "column",
	gap: "16px",
	overflowY: "auto",
	flexGrow: 1,
	"> span": {
		...theme.project.typography.body.body2,
		color: theme.project.colors.fontColors.secondary
	}
}));

export const PricingDefinitionModalDefinitionList = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	gap: "16px"
}));

export const PricingDefinitionModalDefinition = styled.div(({ theme }) => ({
	"> div": {
		display: "flex",
		gap: "12px",
		alignItems: "center",
		"span:first-of-type": {
			...theme.project.typography.subtitle.subtitle2
		},
		"span:nth-of-type(2)": {
			color: theme.project.colors.fontColors.secondary,
			...theme.project.typography.body.body2
		}
	},
	"> span": {
		...theme.project.typography.caption
	}
}));
